(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('consignmentSplitLine', {
        templateUrl: 'views/components/views/consignmentSplitLine/consignmentSplitLine.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'utilityService', 'consignmentSplitLineService', function ($stateParams, stateService, translateService, modalService, utilityService, consignmentSplitLineService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let consignmentLineKeyno = $stateParams.consignmentline_keyno;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                edit: {},
                inputListSplitLines: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
                vm.model.edit = (await consignmentSplitLineService.getEdit({ consignmentline_keyno: consignmentLineKeyno }))[0];
            }

            async function loadSplitLines() {
                if (utilityService.validateParmsValue(vm.model.edit.consignmentline_keyno) !== true) return;

                return vm.model.inputListSplitLines = await consignmentSplitLineService.listSplitLines({ consignmentline_keyno: vm.model.edit.consignmentline_keyno });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region RECALCULATION FUNCTION

            function recalcSumQuantityEntered() {
                setTimeout(() => {
                    vm.model.edit.sum_quantity_entered = 0;

                    vm.model.inputListSplitLines.forEach((line) => {
                        let numberQuantityToPick = utilityService.parseNumber(line.quantity_topick);
                        let numberFixed2Decimals = Math.floor(numberQuantityToPick * 100) / 100;

                        vm.model.edit.sum_quantity_entered += numberFixed2Decimals;
                    }); 

                    if (utilityService.parseNumber(vm.model.edit.quantity_total) !== utilityService.parseNumber(vm.model.edit.sum_quantity_entered)) {
                        vm.model.edit.show_validation_text = '1';
                    } else {
                        vm.model.edit.show_validation_text = '0';
                    }
                }, 500);
            }

            // #endregion RECALCULATION FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id, item) {
                switch (id) {
                    case 'quantity_topick':
                        if (utilityService.validateWatchValue(value, item.quantity_topick) !== true) return;

                        item.quantity_topick = value;

                        if (utilityService.validateParmsValue(item.quantity_topick, true) !== true) return;

                        recalcSumQuantityEntered()
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;
                let inputNumbers = [];

                vm.model.inputListSplitLines.forEach((item) => {
                    inputNumbers.push({
                        consignmentline_keyno: item.consignmentline_keyno,
                        quantity_topick: item.quantity_topick
                    });
                }); 

                consignmentSplitLineService.saveObj({
                    quantity_total: vm.model.edit.quantity_total,
                    consignmentline_keyno: vm.model.edit.consignmentline_keyno,
                    records: inputNumbers
                }).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadEdit();
                loadSplitLines();
                recalcSumQuantityEntered();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
